export default function nodeListForEach(nodes, callback) {
	if (window.NodeList.prototype.forEach) {
		for (const node of nodes) {
			callback(node);
		}
		return;
	}
	for (let index = 0; index < nodes.length; index++) {
		callback.call(window, nodes[index], index, nodes);
	}
}
